import React from "react";
import {
    Heading,
    Text,
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHeaderItem,
    TableItem
} from "spectacle";
import TeaserItem from '../components/TeaserItem';

const ValueBootcamps = ({ content }) =>
    <div className="bootcamp-slide">
        <Heading size={6} textColor="secondary" caps bold>
            {content.title}
        </Heading>
        <Text textSize={25} textColor="primary">
            {content.subtitle}
        </Text>
        <Table padding={30} textColor="secondary">
            <TableHeader>
                <TableRow>
                    <TableHeaderItem></TableHeaderItem>
                    <TableHeaderItem></TableHeaderItem>
                    <TableHeaderItem></TableHeaderItem>
                </TableRow>
            </TableHeader>
            <TableBody>
                <TableRow>
                    {content.items ? content.items.map((item, index) =>
                        <TableItem key={index} className="bootcamp">
                            <TeaserItem item={item} />
                        </TableItem>
                    ) : null}
                </TableRow>
            </TableBody>
        </Table>
    </div>

export default ValueBootcamps;


// WEBPACK FOOTER //
// ./src/slides/ValueBootcamps.js